import React from 'react'
import { DownloadOutlined } from '@ant-design/icons'

const Download = ({ size = '20px', color = '#bfc3cb' }) => {
  return <DownloadOutlined style={{ fontSize: size, color }} />
}

export default Download
